//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sadasi from '@/api/promotores/usuarios/sadasi.api'

export default {
	data() {
		return {
			per_page_options: [10, 20, 30, 40, 50, 100],
			columns: [
				{ 
					name: 'nombre', 
					label: 'Nombre', 
					field: 'nombre', 
					align: 'left',
					classes: "bg-grey-2 ellipsis",
					style: "width: 350px",
					headerClasses: "bg-primary text-white"
				  },
				{ name: 'apellido_paterno', label: 'Apellido Paterno', field: 'apellido_paterno', align: 'left'  },
				{ name: 'apellido_materno', label: 'Apellido Materno', field: 'apellido_materno', align: 'left'  },
				{ name: 'email', label: 'Email', field: 'email', align: 'left'  },
				{ name: 'celular', label: 'Celular', field: 'celular', align: 'left' },
				{ name: 'tipo_credito', label: 'Tipo de Credito', field: 'tipo_credito', align: 'left' },
				{ name: 'status', label: 'Status', field: 'estatus', align: 'left'  },
				{ name: 'created_at', label: 'Creado', field: 'created_at', align: 'left'  },
			],
			data: [],
			loading: false,
		}
	},

	mounted() {
		this.getContacts()
	},

	methods: {
		async getContacts() {
			try {
				this.loading = true
				const solicitudes = await Sadasi.prospects(this.$route.params.promotor)
				this.data = solicitudes.data
			} finally {
				this.loading = false;
			}
		},
	}

}
